import { applyI18n, t } from '../i18n';

export async function renderTiffPreview(
  content: HTMLElement,
  blob: Blob,
): Promise<{ dispose?: () => void } | false> {
  try {
    const utif = await import('utif');
    const arrayBuffer = await blob.arrayBuffer();
    const ifds = utif.decode(arrayBuffer);
    if (!ifds || ifds.length === 0) return false;

    const wrap = document.createElement('div');
    wrap.className = 'file-preview-tiff-wrap';

    const canvas = document.createElement('canvas');
    canvas.className = 'file-preview-tiff';
    wrap.append(canvas);

    let pageIndex = 0;

    const renderPage = (index: number) => {
      const ifd = ifds[index];
      utif.decodeImage(arrayBuffer, ifd);
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      const rgba = utif.toRGBA8(ifd);
      const width = ifd.width as number;
      const height = ifd.height as number;
      canvas.width = width;
      canvas.height = height;
      const imageData = new ImageData(new Uint8ClampedArray(rgba), width, height);
      ctx.putImageData(imageData, 0, 0);
    };

    renderPage(0);

    if (ifds.length > 1) {
      const nav = document.createElement('div');
      nav.className = 'file-preview-tiff-nav';

      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'button ghost file-preview-tiff-nav-btn';
      prev.dataset.i18nAriaLabel = 'files.preview.tiff.prev';
      prev.textContent = '<';

      const status = document.createElement('span');
      status.className = 'file-preview-tiff-status';

      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'button ghost file-preview-tiff-nav-btn';
      next.dataset.i18nAriaLabel = 'files.preview.tiff.next';
      next.textContent = '>';

      const sync = () => {
        const current = pageIndex + 1;
        status.textContent = t('files.preview.tiff.status', { current, total: ifds.length });
        prev.disabled = pageIndex <= 0;
        next.disabled = pageIndex >= ifds.length - 1;
      };

      prev.addEventListener('click', () => {
        if (pageIndex <= 0) return;
        pageIndex -= 1;
        renderPage(pageIndex);
        sync();
      });
      next.addEventListener('click', () => {
        if (pageIndex >= ifds.length - 1) return;
        pageIndex += 1;
        renderPage(pageIndex);
        sync();
      });

      nav.append(prev, status, next);
      wrap.prepend(nav);
      applyI18n(nav);
      sync();
    }

    content.append(wrap);
    return {};
  } catch {
    return false;
  }
}
